module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/example-2-1a16d5137315a44447c68adb76ef5714.png";